import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import secureLocalStorage from "react-secure-storage";
import AuthenticationService from '../../../services/authentication.service';
import DisclaimersService from '../../../services/disclaimers.service';
import { StoredFields } from '../../../enums/StoredFields';
import { RouteNames } from '../../../enums/RouteNames';
import { OneLoginUser } from '../../../interfaces/OneLoginUser';
import { NotificationSeverities } from '../../../enums/NotificationSeverities';
import Notification from '../../../views/notification/Notification';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong during authenticating!'

const Authenticate = () => {
  const navigate = useNavigate();
  const [isErrorNotificationOpen, setIsErrorNotificationOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(DEFAULT_ERROR_MESSAGE);

  useEffect(() => {
    const controller = new AbortController();

    AuthenticationService.getUserManager().signinRedirectCallback()
      .then((data) => {
        const avatar = (data.profile?.params as { profilePicture?: string | null }).profilePicture ?? null;
        const landingRoute = secureLocalStorage.getItem(StoredFields.LANDING_ROUTE);
        const user: OneLoginUser = {
          name: data.profile.name ?? null,
          email: data.profile.email ?? null,
          avatar: avatar,
        };

        secureLocalStorage.setItem(StoredFields.ONE_LOGIN_USER, user);

        navigate(landingRoute && landingRoute !== RouteNames.LOGIN ? String(landingRoute) : RouteNames.HOME);
      })
      .catch((error: Error) => {
        setErrorMessage(error.message.length > 0 ? error.message : DEFAULT_ERROR_MESSAGE);
        setIsErrorNotificationOpen(true);
        setTimeout(() => navigate(RouteNames.LOGIN), 2000);
      });

    DisclaimersService.getImage()
      .then(disclaimer => secureLocalStorage.setItem(StoredFields.IMAGE_DISCLAIMER, disclaimer.attributes.text ?? ''))
      .catch((error: Error) => console.error(error))

    DisclaimersService.getVariation()
      .then(disclaimer => secureLocalStorage.setItem(StoredFields.VARIATION_DISCLAIMER, disclaimer.attributes.text ?? ''))
      .catch((error: Error) => console.error(error))

    return () => controller.abort();
  }, [navigate]);

  return (
    <>
      <Typography>Processing authentication...</Typography>
      <Notification
        open={isErrorNotificationOpen}
        onClose={() => setIsErrorNotificationOpen}
        message={errorMessage}
        severity={NotificationSeverities.ERROR}
      />
    </>
  );
};

export default Authenticate;
